import { exist } from './../exist';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class nestedTabClass {
  constructor() {
    this.nestedTab();
  }

  nestedTab() {
    const select = document.querySelectorAll('.m-nested-tab');
    switch (exist(select)) {
      case true:
        select.forEach((el) => {
          let twoColSlider = el.querySelector(
            '.m-nested-tab-slider__swiper-content',
          );
          let pagination = el.querySelector(
            '.m-nested-tab-slider__swiper-pagination',
          );
          var values = [];
          var swiperSlides = document.querySelectorAll(
            '.m-nested-tab-slider__swiper-content .swiper-slide',
          );

          swiperSlides.forEach(function (slide) {
            var dataValue = slide.getAttribute('data-value');
            if (dataValue) {
              values.push(dataValue);
            }
          });
          const swiper = new Swiper(twoColSlider, {
            autoHeight: true,
            effect: 'fade',
            slidesPerView: 'auto',
            spaceBetween: 22,
            loop: true,
            pagination: {
              el: pagination,
              clickable: true,
              renderBullet: function (index, className) {
                return (
                  '<p class="m-nested-tab-slider__swiper-title m-0 h3 d-flex justify-content-center align-items-center flex-column ' +
                  className +
                  '">' +
                  '<span class="eyebrow-2 d-block">Apply by</span><span class="body-4">' +
                  values[index] +
                  '</span>' +
                  '</p>'
                );
              },
            },
            on: {
              resize: function () {
                if ($(window).width() > 1025) this.destroy();
              },
              slideChange: function () {
                this.update();
              },
            },
          });
        });
        break;
    }
  }
}

export default nestedTabClass;
new nestedTabClass();
